import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Users from './pages/Users'
import Pandits from './pages/Pandits'
import PanditDetails from './pages/PanditDetails'
import Yajman from './pages/Yajman'
import YajmanDetails from './pages/YajmanDetails'
import FeaturedPandits from './pages/FeaturedPandits'
import UnverifiedPandits from './pages/UnverifiedPandits'
import Bookings from './pages/Bookings'
import Services from './pages/Services'
import ELibrary from './pages/ELibrary'
import AddELibrary from './pages/AddELibrary'
import Contact from './pages/Contact'
import Login from './pages/Login'
import Financial from './pages/Financial'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Refund from './pages/Refund'
import LiveStreams from './pages/LiveStreams'
import Festivals from './pages/Festivals'
import PujaCategories from './pages/PujaCategories'
import Pujas from './pages/Pujas'
import Muhurats from './pages/Muhurats'
import AddEditMuhurat from './pages/AddEditMuhurat'
import Broadcast from './pages/Broadcast'
import Testimonials from './pages/Testimonials'
import TirthSthals from './pages/TirthSthals'
import AddEditTirthSthal from './pages/AddEditTirthSthal'
import Banners from './pages/Banners'
import Donations from './pages/Donations'
import VacharManagement from './pages/VacharManagement'

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth()
  return isAuthenticated ? children : <Navigate to="/login" />
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute>
                <Layout>
                  <Users />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/pandits" element={
              <ProtectedRoute>
                <Layout>
                  <Pandits />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/pandits/:id" element={
              <ProtectedRoute>
                <Layout>
                  <PanditDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/yajman" element={
              <ProtectedRoute>
                <Layout>
                  <Yajman />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/yajman/:id" element={
              <ProtectedRoute>
                <Layout>
                  <YajmanDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/featured-pandits" element={
              <ProtectedRoute>
                <Layout>
                  <FeaturedPandits />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/unverified-pandits" element={
              <ProtectedRoute>
                <Layout>
                  <UnverifiedPandits />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/bookings" element={
              <ProtectedRoute>
                <Layout>
                  <Bookings />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/services" element={
              <ProtectedRoute>
                <Layout>
                  <Services />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/elib" element={
              <ProtectedRoute>
                <Layout>
                  <ELibrary />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/elib/add" element={
              <ProtectedRoute>
                <Layout>
                  <AddELibrary />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/contact" element={
              <ProtectedRoute>
                <Layout>
                  <Contact />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financial" element={
              <ProtectedRoute>
                <Layout>
                  <Financial />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/refund" element={
              <ProtectedRoute>
                <Layout>
                  <Refund />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/broadcast" element={
              <ProtectedRoute>
                <Layout>
                  <Broadcast />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/livestreams" element={
              <ProtectedRoute>
                <Layout>
                  <LiveStreams />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/festivals" element={
              <ProtectedRoute>
                <Layout>
                  <Festivals />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/testimonials" element={
              <ProtectedRoute>
                <Layout>
                  <Testimonials />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/puja/categories" element={
              <ProtectedRoute>
                <Layout>
                  <PujaCategories />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/pujas" element={
              <ProtectedRoute>
                <Layout>
                  <Pujas />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/muhurats" element={
              <ProtectedRoute>
                <Layout>
                  <Muhurats />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/muhurats/add" element={
              <ProtectedRoute>
                <Layout>
                  <AddEditMuhurat />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/muhurats/edit/:id" element={
              <ProtectedRoute>
                <Layout>
                  <AddEditMuhurat />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/tirth-sthals" element={
              <ProtectedRoute>
                <Layout>
                  <TirthSthals />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/tirth-sthals/add" element={
              <ProtectedRoute>
                <Layout>
                  <AddEditTirthSthal />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/tirth-sthals/edit/:id" element={
              <ProtectedRoute>
                <Layout>
                  <AddEditTirthSthal />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/banners" element={
              <ProtectedRoute>
                <Layout>
                  <Banners />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/donations" element={
              <ProtectedRoute>
                <Layout>
                  <Donations />
                </Layout>
              </ProtectedRoute>
            } /> 
            <Route path="/vichar-management" element={
              <ProtectedRoute>
                <Layout>
                  <VacharManagement />
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App
